import React, { Component } from 'react'

export default class NotFound extends Component {
  render() {
    return (
      <div>
        您浏览的页面躲起来了～～
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/containers/errors/NotFound.jsx